export const THEMES = {
  ocean:      { label: "🌊 Ocean",      accent: "#0ea5e9", hero: "linear-gradient(135deg,#0c4a6e,#0ea5e9)",   bg: "#f0f9ff", surface: "#ffffff", dark: false, group: "Colour" },
  forest:     { label: "🌿 Forest",     accent: "#16a34a", hero: "linear-gradient(135deg,#14532d,#16a34a)",   bg: "#f0fdf4", surface: "#ffffff", dark: false, group: "Colour" },
  sunset:     { label: "🌅 Sunset",     accent: "#ea580c", hero: "linear-gradient(135deg,#7c2d12,#ea580c)",   bg: "#fff7ed", surface: "#ffffff", dark: false, group: "Colour" },
  galaxy:     { label: "🌌 Galaxy",     accent: "#7c3aed", hero: "linear-gradient(135deg,#2e1065,#7c3aed)",   bg: "#faf5ff", surface: "#ffffff", dark: false, group: "Colour" },
  candy:      { label: "🍬 Candy",      accent: "#ec4899", hero: "linear-gradient(135deg,#831843,#ec4899)",   bg: "#fdf2f8", surface: "#ffffff", dark: false, group: "Colour" },
  golden:     { label: "✨ Golden",     accent: "#d97706", hero: "linear-gradient(135deg,#78350f,#d97706)",   bg: "#fffbeb", surface: "#ffffff", dark: false, group: "Colour" },
  rose:       { label: "🌹 Rose",       accent: "#e11d48", hero: "linear-gradient(135deg,#881337,#e11d48)",   bg: "#fff1f2", surface: "#ffffff", dark: false, group: "Colour" },
  lavender:   { label: "🪻 Lavender",   accent: "#8b5cf6", hero: "linear-gradient(135deg,#4c1d95,#8b5cf6)",   bg: "#f5f3ff", surface: "#ffffff", dark: false, group: "Colour" },
  ice:        { label: "🩵 Ice",        accent: "#38bdf8", hero: "linear-gradient(135deg,#075985,#38bdf8)",   bg: "#f0f9ff", surface: "#f8fbff", dark: false, group: "Colour" },
  tangerine:  { label: "🍊 Tangerine",  accent: "#f97316", hero: "linear-gradient(135deg,#9a3412,#f97316)",   bg: "#fff7ed", surface: "#ffffff", dark: false, group: "Colour" },
  mint:       { label: "🌿 Mint",       accent: "#14b8a6", hero: "linear-gradient(135deg,#134e4a,#14b8a6)",   bg: "#f0fdfa", surface: "#ffffff", dark: false, group: "Colour" },
  midnight:   { label: "🌙 Midnight",   accent: "#6366f1", hero: "linear-gradient(135deg,#1e1b4b,#6366f1)",   bg: "#0f172a", surface: "#1e293b", dark: true,  group: "Colour" },
  spring:     { label: "🌸 Spring",     accent: "#f472b6", hero: "linear-gradient(135deg,#9d174d,#f472b6,#86efac)", bg: "#fdf4ff", surface: "#ffffff", dark: false, group: "Seasonal" },
  summer:     { label: "☀️ Summer",     accent: "#facc15", hero: "linear-gradient(135deg,#b45309,#facc15,#fb923c)", bg: "#fffbeb", surface: "#ffffff", dark: false, group: "Seasonal" },
  autumn:     { label: "🍂 Autumn",     accent: "#b45309", hero: "linear-gradient(135deg,#431407,#b45309,#dc2626)", bg: "#fef3c7", surface: "#fffbf0", dark: false, group: "Seasonal" },
  winter:     { label: "❄️ Winter",     accent: "#7dd3fc", hero: "linear-gradient(135deg,#1e3a5f,#7dd3fc,#e0f2fe)", bg: "#f0f9ff", surface: "#f8faff", dark: false, group: "Seasonal" },
  calm:       { label: "🧘 Calm",       accent: "#84cc16", hero: "linear-gradient(135deg,#365314,#84cc16,#a8a29e)", bg: "#f7fee7", surface: "#fafaf9", dark: false, group: "Mood" },
  energise:   { label: "⚡ Energise",   accent: "#eab308", hero: "linear-gradient(135deg,#d97706,#eab308,#f87171)", bg: "#fefce8", surface: "#ffffff", dark: false, group: "Mood" },
  focus:      { label: "🎯 Focus",      accent: "#3b82f6", hero: "linear-gradient(135deg,#1e3a8a,#3b82f6)",   bg: "#f8fafc", surface: "#ffffff", dark: false, group: "Mood" },
  dreamy:     { label: "🌙 Dreamy",     accent: "#a78bfa", hero: "linear-gradient(135deg,#4c1d95,#a78bfa,#fda4af)", bg: "#faf5ff", surface: "#fff8ff", dark: false, group: "Mood" },
};

const BASE_LIGHT = {
  "--bg": "#f8fafc", "--surface": "#ffffff", "--surface2": "#f1f5f9",
  "--border": "#e2e8f0", "--ink": "#1e293b", "--navy": "#0f172a", "--muted": "#64748b",
  "--green": "#16a34a", "--green-light": "#dcfce7",
  "--red": "#dc2626", "--red-light": "#fee2e2",
  "--amber": "#d97706", "--amber-light": "#fef3c7",
  "--topbar-bg": "#ffffff",
};
const BASE_DARK = {
  "--bg": "#0f172a", "--surface": "#1e293b", "--surface2": "#334155",
  "--border": "#334155", "--ink": "#e2e8f0", "--navy": "#f1f5f9", "--muted": "#94a3b8",
  "--green": "#22c55e", "--green-light": "#14532d",
  "--red": "#f87171", "--red-light": "#450a0a",
  "--amber": "#fbbf24", "--amber-light": "#451a03",
  "--topbar-bg": "#1e293b",
};

export function lightenHex(hex) {
  const map = {
    "#0ea5e9": "#e0f2fe", "#16a34a": "#dcfce7", "#ea580c": "#ffedd5",
    "#7c3aed": "#ede9fe", "#ec4899": "#fce7f3", "#d97706": "#fef3c7",
    "#e11d48": "#ffe4e6", "#8b5cf6": "#ede9fe", "#38bdf8": "#e0f2fe",
    "#f97316": "#ffedd5", "#14b8a6": "#ccfbf1", "#6366f1": "#e0e7ff",
    "#f472b6": "#fce7f3", "#facc15": "#fef9c3", "#b45309": "#fef3c7",
    "#7dd3fc": "#e0f2fe",
    "#84cc16": "#ecfccb", "#eab308": "#fef9c3", "#3b82f6": "#dbeafe",
    "#a78bfa": "#ede9fe",
  };
  return map[hex] || "#dbeafe";
}

export function applyTheme(themeKey) {
  const t = THEMES[themeKey] || THEMES.ocean;
  const base = t.dark ? BASE_DARK : BASE_LIGHT;
  const vars = {
    ...base,
    "--blue": t.accent,
    "--blue-light": t.dark ? "#1e3a5f" : lightenHex(t.accent),
    "--hero-grad": t.hero,
  };
  if (t.dark || themeKey === "midnight") {
    vars["--bg"] = "#0f172a"; vars["--surface"] = "#1e293b";
    vars["--surface2"] = "#334155"; vars["--border"] = "#334155";
    vars["--ink"] = "#e2e8f0"; vars["--navy"] = "#f1f5f9";
    vars["--muted"] = "#94a3b8"; vars["--topbar-bg"] = "#1e293b";
  } else {
    vars["--bg"] = t.bg; vars["--surface"] = t.surface;
  }
  Object.entries(vars).forEach(([k, v]) => document.documentElement.style.setProperty(k, v));
}
